import React from 'react';
import {
  khachHangSearchColumns,
  khoHangSearchColumns,
  nhomColumns,
  QUERY_KEYS,
  regionColumns,
  vatTuSearchColumns
} from '@/constants';
import { KhachHang, KhoHang, KhuVuc, VatTu } from '@/types/schemas';
import { FormField, SearchField } from '@/components/custom/erp';
import { useLoaiVatTu } from '@/hooks/queries';
import { Label } from '@/components/ui/label';

const DetailsTab: React.FC = () => {
  const { loaiVatTus } = useLoaiVatTu();

  const loaiVatTuOptions = loaiVatTus.map(item => ({
    value: item.uuid,
    label: `${item.ma_lvt} - ${item.ten_lvt}`
  }));
  return (
    <div className='w-[800px] min-w-[800px] space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        {/* 1. Mã khách hàng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã khách hàng:</Label>
          <SearchField<KhachHang>
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
            searchColumns={khachHangSearchColumns}
            dialogTitle='Danh mục khách hàng'
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
          />
        </div>

        {/* 2. Nhóm khách hàng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm khách hàng:</Label>
          <div className='flex-1'>
            <div className='flex gap-1'>
              <SearchField
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC1`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm khách hàng'
                columnDisplay='ma_nhom'
              />
              <SearchField
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC2`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm khách hàng'
                columnDisplay='ma_nhom'
              />
              <SearchField
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC3`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm khách hàng'
                columnDisplay='ma_nhom'
              />
            </div>
          </div>
        </div>

        {/* 3. Khu vực */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Khu vực:</Label>
          <SearchField<KhuVuc>
            searchEndpoint={`/${QUERY_KEYS.KHU_VUC}/`}
            searchColumns={regionColumns}
            dialogTitle='Danh mục khu vực'
            columnDisplay='rg_code'
            displayRelatedField='rgname'
          />
        </div>

        {/* 5. Mã vật tư */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã vật tư:</Label>
          <SearchField<VatTu>
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
            searchColumns={vatTuSearchColumns}
            dialogTitle='Danh mục vật tư'
            columnDisplay='ma_vt'
            displayRelatedField='ten_vt'
          />
        </div>

        {/* 6. Loại vật tư */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Loại vật tư:</Label>
          <div className='flex-1'>
            <div className='flex items-center gap-4'>
              <div className='flex-1'>
                <FormField name='ma_lvt' type='select' options={loaiVatTuOptions} />
              </div>
              <div className='whitespace-nowrap'>
                <FormField name='ton_kho_yn' type='checkbox' label='Chỉ xem vật tư có theo dõi tồn kho' />
              </div>
            </div>
          </div>
        </div>

        {/* 7. Nhóm vật tư */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm vật tư:</Label>
          <div className='flex-1'>
            <div className='flex gap-1'>
              <SearchField
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=VT1`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm vật tư'
                columnDisplay='ma_nhom'
              />
              <SearchField
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=VT2`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm vật tư'
                columnDisplay='ma_nhom'
              />
              <SearchField
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=VT3`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm vật tư'
                columnDisplay='ma_nhom'
              />
            </div>
          </div>
        </div>

        {/* 8. Mã kho */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã kho:</Label>
          <SearchField<KhoHang>
            searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
            searchColumns={khoHangSearchColumns}
            dialogTitle='Danh mục kho hàng'
            columnDisplay='ma_kho'
            displayRelatedField='ten_kho'
          />
        </div>

        {/* 9. Mẫu báo cáo */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mẫu báo cáo:</Label>
          <div className='flex-1'>
            <FormField
              name='reportTemplate'
              type='select'
              options={[
                { value: 'quantity', label: 'Mẫu số lượng' },
                {
                  value: 'quantityAndValue',
                  label: 'Mẫu số lượng và giá trị'
                },
                {
                  value: 'quantityAndForeignValue',
                  label: 'Mẫu số lượng và giá trị ngoại tệ'
                }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
